import { type JSX } from 'react';
import { Navigate, Outlet } from 'react-router';
import Loading from '@common/components/Loading';
import useAccessRights from '@common/hooks/useAccessRights';
import { type RightName } from '@common/utils/accessRights';

type RestrictedRouteProps = {
  requiredRight: RightName;
  onViolation: string | JSX.Element;
};

function RestrictedRouteContainer({
  requiredRight,
  onViolation,
}: Readonly<RestrictedRouteProps>): JSX.Element {
  const { currentUser, [requiredRight]: allowed } = useAccessRights();

  if (!currentUser) {
    return <Loading />;
  }
  if (allowed) {
    return <Outlet />;
  }
  if (typeof onViolation === 'string' && onViolation.startsWith('/')) {
    return <Navigate to={onViolation} />;
  }
  return (
    <>
      {onViolation}
    </>
  );
}

export default RestrictedRouteContainer;
